export const getOpener = () => window.opener;
export const getOrigin = () => window.location.origin;
export const getPathName = () => window.location.pathname;